import { JWMHtml } from "@components/JWMHtml/JWMHtml";
import useJnjBranding from "@jmc/utils/hooks/useJnjBranding";
import { CMSBlock } from "@jwm/types/CMSBlock";
import { default as cmsMapper } from "@utils/cms-mapper";
import classnames from "classnames";
import React, { CSSProperties } from "react";

import style from "../style.module.scss";
import { trackingHelpersProps } from "../types";

interface TextBlockProps {
    content: CMSBlock["text"];
    placement?: string;
    textColor?: string;
    refColor?: string;
    visitedLinkColor?: string;
    siteSpecialty?: {
        type: string;
        title: string;
    };
    trackingHelpers: trackingHelpersProps;
    sectionIndex: number;
}

export const TextBlock = ({
    content,
    placement,
    textColor,
    refColor,
    visitedLinkColor,
    siteSpecialty,
    trackingHelpers,
    sectionIndex,
}: TextBlockProps): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();

    trackingHelpers.position++;
    const columnWidth = content?.automatic_columns_division;
    const textBorder = content?.layout_options?.border;

    const styles = { columnWidth: columnWidth ? `${columnWidth.toString()}ch` : "auto" } as CSSProperties;
    return (
        <div style={styles} className={classnames(style.text, textBorder ? style.text__border : null)}>
            <span
                style={
                    {
                        color: `var(${jnjFullBranded ? "--text-02" : cmsMapper.mapSectionTextColors(textColor)})`,
                        "--text-link": `var(${
                            jnjFullBranded ? "--primary-550" : cmsMapper.mapSectionTextColors(refColor)
                        })`,
                        "--text-link-visited": `var(${
                            jnjFullBranded ? "--primary-550" : cmsMapper.mapSectionTextColors(visitedLinkColor)
                        })`,
                    } as React.CSSProperties
                }
            >
                <JWMHtml
                    color="inherit"
                    useLargeText={jnjFullBranded}
                    placement={placement}
                    margins
                    siteSpecialty={siteSpecialty}
                    loading={sectionIndex === 0 ? "eager" : "lazy"}
                >
                    {content?.textual_content}
                </JWMHtml>
            </span>
        </div>
    );
};
